import template from './sw-help-center.html.twig';
import './sw-help-center.scss';

/**
 * @package admin
 *
 * @private
 */
// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
Shopware.Component.register('sw-help-center', {
    template,
});
